.details {
  box-shadow: var(--shadows-soft);
  clip-path: inset(-16px 0 0 0);
}
